/**
 *  Created by Aneree on 15/01/21.
 */
import { useRef } from 'react';
var useLatest = function (value) {
    var ref = useRef(value);
    ref.current = value;
    return ref;
};
export { useLatest };
